import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('wordpress'),
  titleToNamespace: true,
  hasConnectionStatus: false,
  avatarPath: avatars.wordpress,
  logoPath: logos.wordpress
});
